import React from 'react';
import {Link} from "react-router-dom";
import {Helper, ProductsetupQuantityAndRatio} from './Helper'

export default class PurchaseRequest extends React.Component {
	constructor(props) {
		super(props);

		let _state = {};
		_state.params = {};
		window.Route.on({
			'/v2/purchase-request': () => {
				_state = {
					mode: 'list',
				};
			},
			'/v2/purchase-request/new': () => {
				_state = {
					mode: 'create',
				};
			},
			'/v2/purchase-request/:product_request_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
				};
			},
			'/v2/purchase-request/:product_request_id/edit': (params) => {
				_state = {
					mode: 'edit',
					params: params,
				};
			},
		}).match();
		_state.product_request = false;
		_state.product_requests = [];
		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();
		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/purchase-request': () => {
					this.setState({
						mode: 'list',
						is_loading: true,
						product_request: false,
						product_requests: [],
					}, () => {
						this.fetch();
					})
				},
				'/v2/purchase-request/new': () => {
					this.setState({
						mode: 'create',
						is_loading: true,
						product_request: false,
						product_requests: [],

					}, () => {
						this.create();
					})
				},
				'/v2/purchase-request/:product_request_id': (params) => {
					this.setState({
						mode: 'view',
						is_loading: true,
						params: params,
						product_request: false,
						product_requests: [],
					}, () => {
						this.view();
					});
				},
				'/v2/purchase-request/:product_request_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						params: params,
						product_request: false,
						product_requests: [],
					}, () => {
						this.edit();
					});
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				products: [],
				product_price_condition: [],
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'view') {
			this.view();
		}
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'create') {
			this.create();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
	}

	create() {
		let response_running_number = [];
		window.Global.getDataViaMultiAjax().load({
			'running_number': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/running_number',
				data: {all: true},
				done: function (response) {
					if (!response.success) return false;
					response_running_number = response['running_number'];
				}
			}
		}).done(() => {
			window.GlobalFunc.handleCodeInput({
				$node: window.$(this.$parent).find('.RunningNumber_root'),
				$custom_running_number: window.$(this.$parent).find('.custom-running-number'),
				running_number: response_running_number,
				running_number_id: "purchase_order"
			});
		});

		this.setState({
			is_loading: false,
		});
	}

	edit() {

	}

	fetch() {
		// alert("Fetch");
		let data = window.Global.getAllQueryStrings();
		console.log(data);
		let loading = setTimeout(() => {
			this.setState({
				is_loading: false,
			}, () => {
				clearTimeout(loading);
			})
		}, 1000)

	}

	view() {

	}

	onItemUpdate() {
		let $parent = window.$('#clear-advance-payment-root');
		let items = $parent.find('form').serializeObject()['item'];
		let summary = window.GlobalFunc.calculateSummary($parent, {
				tax_type: 'none',
				withholding_tax_percent: 0,
				total_price_withholding_tax: 0,
			},
			((items ? items : []).filter(() => {
				return true;
			}))
		);

		window.GlobalFunc.showSummary2(
			$parent.find('.Summary_root'),
			summary,
			{
				tax: false,
				discount: false
			}
		);

		return summary;

	}


	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				{/*HEADER*/}
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/purchase-request">จัดซื้อ</Link>
						</div>
					</div>
					<div className="right floated">
						<Link id="addProductButton" to="/v2/purchase-request/new"
						      className="ui positive button">เพิ่มใบจัดซื้อ</Link>
					</div>
				</div>
				{/*SEARCH*/}
				<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
				     ref={(ref) => {
					     let $search = window.$(ref);

					     window.Search.init({
						     $node: $search,
						     onSubmit: (data) => {
							     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
							     return false;
						     }
					     });
					     $search.find('input[name="user_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/user',
						     additionalData: {
							     limit: 30,
							     page: 1,
							     type: 'user'
						     },
						     key: 'user',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });

				     }}
				>
					<form className="ui form">
						<div className="flex row wrap padded five column computer">
							<div className="column field">
								<label>ค้นหารหัสจัดซื้อ</label>
								<input name="search_query" data-form2_setup="" placeholder={"รหัสจัดซื้อ"}/>
							</div>
							<div className="column field">
								<label>สถานะการอนุมัติ</label>
								<div className="field">
									<select className="ui dropdown"
									        name="is_serial_number"
									        data-form2_setup="">
										<option value="all">ทั้งหมด</option>
										<option value="wait_for_approve">รออนุมัติ</option>
										<option value="approve">อนุมัติ</option>
										<option value="cancel">ไม่อนุมัติ</option>
									</select>
								</div>
							</div>
							<div className="column field">
								<label>สถานะการสร้างใบ PO</label>
								<div className="field">
									<select className="ui dropdown"
									        name="is_not_count_stock"
									        data-form2_setup="">
										<option value="all">ทั้งหมด</option>
										<option value="wait">รอดำเนินการ</option>
										<option value="some_part">บางส่วน</option>
										<option value="full">เสร็จสิ้น</option>
									</select>
								</div>
							</div>
							<div className="column field">
								<label>ผู้บันทึก</label>
								<input name="user_id" data-form2_setup="" placeholder={"ผู้บันทึก"}/>
							</div>
							<div className="column fluid right floated">
								<label style={{opacity: 0}}>อื่นๆ</label>
								<div className="flex row wrap right floated end-xs">
									<button className="ui icon button" type="submit">
										<i className="search icon"/> ค้นหา
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
				{/*TABLE*/}
				<div className="flex row wrap">
					<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: '1rem'}}>
						<div className="thead">
							<div className="tr">
								<div className="th span12">ชื่อ</div>
								<div className="th span4">รหัสสินค้า</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.is_loading
									? <div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"/>
										</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.product_requests.length === 0
								&& (
									!window.Global.getAllQueryStrings().page
									|| window.Global.getAllQueryStrings().page === '1'
								) ?
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.product_requests.length > 0 ?
									this.state.product_requests.map((product, product_i) => {
										return (
											<Link to={"/v2/products/" + product.id} className="tr" key={product_i}>
												<div className="td span12">

												</div>
												<div className="td span4">
													{product.code}
												</div>

											</Link>
										)
									}) : null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') {
			return this.renderView();
		}
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		return (
			<>
				<div ref={(ref) => {
					if (!ref) return;
					this.$parent = window.$(ref);
				}}
				     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				     className="main ui container">
					{/*HEADER*/}
					<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
						<div className="flex row middle-xs center-xs">
							<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
								<Link className="active section" to="/v2/purchase-request">จัดซื้อ</Link>
								<span className="divider" style={{margin: '0px 1rem'}}>/</span>
								<div className="section">{this.state.mode === "create" ? "เพิ่ม" : "แก้ไข"}</div>
							</div>
						</div>
					</div>
					{/*SEARCH*/}
					<form id="Signature_root"
					      ref={(ref) => {
						      window.$(ref).form2('setup');
					      }}
					      className={this.state.is_loading ? "ui form ui tall stacked loading segment" : "ui form ui tall stacked segment"}
					      autoComplete="off">
						<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
							<h2 style={{margin: 0}}>
								{this.state.mode === 'edit' ? 'แก้ไข' : null}
								จัดซื้อ
								{this.state.mode === 'create' ? 'ใหม่' : null}
							</h2>
						</div>
						<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
						<div className={"flex row wrap padded four column computer"}>
							<div className="column field required custom-running-number">
								<label className="flex row">
									เลขที่เอกสาร
									{
										this.state.mode === 'create' ?
											<span className="ui checkbox"
											      data-form2_setup="true"
											      style={{marginLeft: '0.5rem'}}>
												<input type="checkbox"
												       tabIndex="-1"
												       className="hidden"
												       name="is_code_generate_auto"
												       id={"is_code_generate_auto"}
												       defaultChecked="checked"/>
												<label htmlFor="is_code_generate_auto"
												       style={{paddingLeft: '1.5em'}}>Auto</label>
											</span>
											:
											null
									}
								</label>
								<input type="text" name="doc_no"/>
							</div>
							<div className="column field">
								<label>วันที่เอกสาร</label>
								<div data-form_calendar="date"
								     data-input_name="doc_date"
								     data-placeholder={"วันที่เอกสาร"}
								     data-locale="th"
								     data-initialdate={"now"}
								/>
							</div>
						</div>
						<div className="flex row padded wrap one column computer">
							<div className="column">
								<h4 className="ui dividing header">รายละเอียด</h4>
								<div className="ui basic table Table_root theme1 td-top-xs">
									<div className="thead">
										<div className="tr">
											<div className="th span12">รายละเอียด</div>
											<div className="th span4">จำนวน</div>
										</div>
									</div>
									<div className="tbody Item_root">
										{
											this.state.mode === 'edit'
												?
												this.state.product_requests.is_approve === null
													?
													this.state.product_requests.map((payment_item, key) => {
														return (
															<PurchaseRequestItem
																key={key}
																mode="edit"
																payment_item={payment_item}
																onItemUpdate={this.onItemUpdate}
																// isApprove={this.state.payment.is_approve}
															/>
														)
													})
													:
													this.state.product_requests.map((payment_item, key) => {
														return (
															<PurchaseRequestItem
																key={key}
																mode="view"
																payment_item={payment_item}
																onItemUpdate={this.onItemUpdate}
																// isApprove={this.state.payment.is_approve}
															/>
														)
													})
												: null
										}
									</div>
									<div className="tr">
										<div className="td flex span16 center-xs">
											<div>
												<div className="ui basic button"
												     onClick={() => {
													     window.GlobalFunc.reactToDom(
														     window.$(this.$parent).find('.Item_root'),
														     PurchaseRequestItem, {
															     mode: 'create',
															     payment_item: {
																     title: "จัดซื้อ",
																     description: '',
																     quantity: 1,
																     ratio: 1,
																     price: 0,
															     },
															     onItemUpdate: this.onItemUpdate,
														     }
													     );
												     }}
												>
													<i className="plus icon"/>
													เพิ่มรายการ
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="ui error message"/>
						<div className="flex row">
							<Link
								to={this.state.mode === 'create' ? '/v2/purchase-request' : '/v2/purchase-request/' + this.state.puschase_request.id}
								className={"ui button"}>ยกเลิก</Link>
							<div className="right floated">
								{
									this.state.relationship && this.state.relationship.id ?
										<input type={"hidden"} name={"relationship_id"}
										       defaultValue={this.state.relationship.id}/>
										: null
								}
								{
									this.state.relationship_address && this.state.relationship_address.id ?
										<input type={"hidden"} name={"relationship_address_id"}
										       defaultValue={this.state.relationship_address.id}/>
										: null
								}

								<button id="submitDraftButton" className="ui button" type="button">
									ฉบับร่าง
								</button>
								<button id="submitButton" className="ui positive button" type="submit">
									{this.state.mode === 'create' ? 'ยืนยันสร้างใบจัดซื้อ' : null}
									{this.state.mode === 'edit' ? 'บันทึก' : null}
								</button>
							</div>
						</div>
					</form>
				</div>
			</>
		)
	}
}


class PurchaseRequestItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: this.props.mode,
			title: this.props.payment_item.title,
			description: this.props.payment_item.description,
			quantity: this.props.payment_item.quantity,
			ratio: this.props.payment_item.ratio,
			price: parseFloat(this.props.payment_item.price),
			product: {}
		};
	}

	componentDidMount() {
		window.$(this.ref).find('textarea[name="item[][description]"]').autoHeight();

		this.onChange();
	}

	remove() {
		window.$(this.ref).remove();
		this.onChange();
	}

	onChange() {
		this.props.onItemUpdate();
	}

	render() {
		// console.log(this.state.product);
		return (
			<div
				ref={(ref) => {
					this.ref = ref;
				}}
				className="tr Item_each"
			>
				<div className="td span12">
					{
						this.state.mode === 'view' ?
							<div>
								<div>{this.state.title}</div>
								<div style={{whiteSpace: 'pre-line'}}>{this.state.description}</div>
							</div>
							: null
					}
					{
						this.state.mode !== 'view' ?
							<div>
								{
									this.state.product.id ?
										<div className="item flex row middle-xs">
											<img className="ui avatar image"
											     src={this.state.product.product_image_file_upload.url}
											     alt={"Product"}
											/>
											<div style={{flex: 1}}>
												<div>{this.state.product.name}</div>
												<div className="description" style={{marginTop: 5}}>
													<textarea className="description-input"
													          name="item[][description]"
													          placeholder="คำอธิบายเพิ่มเติม"
													          defaultValue={this.state.description}
													          spellCheck="false"
													          rows={1}
													          style={{lineHeight:'initial'}}
													/>
												</div>
											</div>
										</div>
										: null
								}
								<div
									className={this.state.product.id ? 'hidden' : ''}>
									<input type="text"
									       name="item[][name]"
									       placeholder="รายละเอียด"
									       defaultValue={this.state.title}
									       style={{marginBottom: '0.5rem'}}
									       ref={(ref) => {
										       window.$(ref).explorer({
											       url: process.env.REACT_APP_DOMAIN + '/api/product',
											       additionalData: {
												       limit: 10,
												       page: 1
											       },
											       key: 'product',
											       template: {
												       list: '<a class="item flex row middle-xs"><img class="ui avatar image" src="{{product_image_file_upload.url}}">{{name}}</a>',
												       selected: {
													       text: 'name',
													       value: 'id',
													       placeholder: ''
												       }
											       },
											       onSelected: (reponse) => {
												       this.setState({
													       product: reponse
												       })
											       }
										       });
										       let _focus = setTimeout(() => {
											       window.$(this.ref).find('.list input[name="search"]').focus();
											       clearTimeout(_focus);
										       });
									       }}
									/>
								</div>
							</div>
							: null
					}
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								this.state.mode === 'view' ?
									<div>
										{this.state.price.format(2)}
										<input type="hidden" name="item[][price]" value={this.state.price}/>
									</div>
									:
									<div>
										{
											this.state.product.id ?
												<div id={"ratio"}
												     ref={(ref) => {
													     ProductsetupQuantityAndRatio.setupQuantityAndRatio(ref, this.state.product);
												     }}
												/>
												: null
										}

										{
											this.state.product
											&& this.state.product.product_stock
											&& this.state.product.product_stock[0] ?
												<div className="Item_quantityAfter qty-after">
													{
														this.state.product
														&& this.state.product.product_stock
														&& this.state.product.product_stock[0].on_hand ?
															"ในคลัง " + this.state.product.product_stock[0].on_hand.format(2) + ' ' + Helper.getRatioUnit(this.state.product, this.state.product.default_item_sell.ratio).unit_name + ' '
															: null
													}
												</div>
												: null
										}
									</div>
							}
						</div>
						{
							!this.props.isApprove ?
								<div className="right floated"
								     style={
									     this.props.is_can_remove !== undefined
									     && !this.props.is_can_remove
										     ? {display: 'none'}
										     : null
								     }>
									<button type={"button"}
									        className={"ui icon button remove"}
									        onClick={() => {
										        this.remove();
									        }}
									>
										<i className="remove icon" style={{margin: 0}}/>
									</button>
								</div>
								:
								null
						}

					</div>
				</div>
			</div>
		);
	}
}